<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import StrategyMediaList from '@/strategies/StrategyMediaList.vue'
import AnchorSaveToLibraryPanel from '../AnchorSaveToLibraryPanel.vue'
import ProgressMonitoringPanel from '../ProgressMonitoringPanel.vue'
import { useAnchorPageStore } from '../anchor_page.store'
import AnchorPageStandards from './AnchorPageStandards.vue'
import { anchorSidebarHeadingClasses } from './anchor_sidebar_headings'

defineSlots<{
  review?(): unknown
}>()

const anchorPageStore = useAnchorPageStore()
const { content, hasPMAs, hasAccordionObjectives, strategies } = storeToRefs(anchorPageStore)

const title = computed(() => content.value?.title ?? '')
const contentUuid = computed(() => content.value?.uuid ?? '')
const isProgressMonitoringShown = computed(() => Boolean(title.value && contentUuid.value) && !hasPMAs.value)
const sectionHeadingClasses = computed(() => anchorSidebarHeadingClasses(hasAccordionObjectives.value))
</script>

<template>
  <div class="flex flex-wrap">
    <div class="w-1/2 md:w-full" :class="{ 'mt-5': hasAccordionObjectives }">
      <AnchorSaveToLibraryPanel>
        <slot name="review" />
      </AnchorSaveToLibraryPanel>
    </div>
  </div>

  <ProgressMonitoringPanel v-if="isProgressMonitoringShown" content-type="anchor" :content-title="title" :content-uuid="contentUuid" />

  <AnchorPageStandards />

  <template v-if="strategies.length > 0">
    <h2 :class="sectionHeadingClasses">Referenced Strategies</h2>
    <StrategyMediaList :strategies="strategies" />
  </template>
</template>
